var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3015_8031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 3.75C2.625 3.33579 2.96079 3 3.375 3H14.625C15.0392 3 15.375 3.33579 15.375 3.75V16.5C15.375 16.9142 15.0392 17.25 14.625 17.25H3.375C2.96079 17.25 2.625 16.9142 2.625 16.5V3.75ZM4.125 4.5V15.75H13.875V4.5H4.125Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5V12.375C8.25 12.7892 7.91421 13.125 7.5 13.125C7.08579 13.125 6.75 12.7892 6.75 12.375V7.5C6.75 7.08579 7.08579 6.75 7.5 6.75Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.75C10.9142 6.75 11.25 7.08579 11.25 7.5V12.375C11.25 12.7892 10.9142 13.125 10.5 13.125C10.0858 13.125 9.75 12.7892 9.75 12.375V7.5C9.75 7.08579 10.0858 6.75 10.5 6.75Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 3.75C0.75 3.33579 1.08579 3 1.5 3H16.5C16.9142 3 17.25 3.33579 17.25 3.75C17.25 4.16421 16.9142 4.5 16.5 4.5H1.5C1.08579 4.5 0.75 4.16421 0.75 3.75Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5757 1.13949C6.70736 0.899308 6.95948 0.75 7.23338 0.75H10.7914C11.0676 0.75 11.3214 0.901791 11.4521 1.1451L12.6607 3.3951C12.7856 3.62753 12.7791 3.90847 12.6437 4.13492C12.5083 4.36136 12.2638 4.5 12 4.5H6C5.73502 4.5 5.4897 4.36017 5.35468 4.13217C5.21965 3.90418 5.21496 3.62185 5.34233 3.38949L6.5757 1.13949ZM7.67754 2.25L7.26642 3H10.7458L10.3429 2.25H7.67754Z",
    fill: "#FF0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3015_8031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a8c897f1021841081d9b738984e2a2e0.svg";
export { ForwardRef as ReactComponent };